export const rootCustomProperty = valueName => {
	return getComputedStyle(document.documentElement).getPropertyValue(valueName)
}
export const ONE_SECOND_IN_MS = 1000
